/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoValidateShipmentEoriInput = {
    clientMutationId?: string | null;
    shipmentSlug: string;
    generateDocument?: boolean | null;
};
export type ShipmentCompanyCardEoriMutationVariables = {
    input: infoValidateShipmentEoriInput;
};
export type ShipmentCompanyCardEoriMutationResponse = {
    readonly infoValidateShipmentEori: {
        readonly clientMutationId: string | null;
        readonly docGenerated: boolean;
    } | null;
};
export type ShipmentCompanyCardEoriMutation = {
    readonly response: ShipmentCompanyCardEoriMutationResponse;
    readonly variables: ShipmentCompanyCardEoriMutationVariables;
};



/*
mutation ShipmentCompanyCardEoriMutation(
  $input: infoValidateShipmentEoriInput!
) {
  infoValidateShipmentEori(input: $input) {
    clientMutationId
    docGenerated
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoValidateShipmentEoriPayload",
    "kind": "LinkedField",
    "name": "infoValidateShipmentEori",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "docGenerated",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShipmentCompanyCardEoriMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShipmentCompanyCardEoriMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9f13dc228c27b3a3f874d495dff48e71",
    "id": null,
    "metadata": {},
    "name": "ShipmentCompanyCardEoriMutation",
    "operationKind": "mutation",
    "text": "mutation ShipmentCompanyCardEoriMutation(\n  $input: infoValidateShipmentEoriInput!\n) {\n  infoValidateShipmentEori(input: $input) {\n    clientMutationId\n    docGenerated\n  }\n}\n"
  }
};
})();
(node as any).hash = 'aa6c85598c2305151f209e1b48b24605';
export default node;
